import { ICalculationStatement } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getCalculationStatements = (id: string): Promise<ICalculationStatement[]> =>
  API.get(`/api/accommodation/calculations/${id}/statements`).then(response => response?.data);
